import { render, staticRenderFns } from "./BankListAutoWithdrawal.vue?vue&type=template&id=a6d4dec4&lang=pug"
import script from "./BankListAutoWithdrawal.vue?vue&type=script&lang=js"
export * from "./BankListAutoWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports